import React from "react";
import FlexGrid from "../../modules/FlexGrid";
import Image from "../../elements/Image";
import getClassNameFactory from "../../utilities/classNames";

var Stepper = function Stepper(_ref) {
  var steps = _ref.steps,
      currentStep = _ref.currentStep;
  var getClassName = getClassNameFactory(Stepper.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "wrapper"
    })
  }, /*#__PURE__*/React.createElement(FlexGrid.Row, null, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    className: getClassName({
      descendantName: "firstCol"
    })
  }, steps[currentStep].image && /*#__PURE__*/React.createElement(Image, {
    src: steps[currentStep].image || "",
    width: 82,
    height: 82,
    alt: steps[currentStep].imageAlt || ""
  })), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    className: getClassName({
      descendantName: "secondCol"
    })
  }, steps.map(function (_ref2, i) {
    var text = _ref2.text;
    var isCurrentStep = i === currentStep;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: getClassName({
        descendantName: "step",
        modifiers: "".concat(isCurrentStep ? "currentStep" : "")
      })
    }, text);
  }))));
};

Stepper.displayName = "Stepper";
export default Stepper;